import { render } from "./modifyAddress.vue?vue&type=template&id=991f1306"
import script from "./modifyAddress.vue?vue&type=script&lang=js"
export * from "./modifyAddress.vue?vue&type=script&lang=js"

import "./modifyAddress.vue?vue&type=style&index=0&id=991f1306&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__